import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AuditLogsTable from '@components/Tables/AuditLogsTable';
import AuditLogsFilters from '@components/Tables/AuditLogsTable/AuditLogsFilters';

import { EventType } from '@constants/event_types';

import { useAuditLogs, useAuditLogUserFilter } from '@hooks/api/audit-logs';

import MainWrapper from '@views/Records/Common/MainWrapper';

const messages = defineMessages({
  title: { id: 'auditLogsMain.title', defaultMessage: 'Audit Logs' },
});

function AuditLogsContent() {
  const {
    auditLogs,
    loading,
    total,
    page,
    setPage,
    pageSize,
    setPageSize,
    setFilters,
  } = useAuditLogs({});

  const { uniqueUsers } = useAuditLogUserFilter();

  return (
    <AuditLogsTable
      auditLogs={auditLogs}
      total={total}
      page={page}
      setPage={setPage}
      pageSize={pageSize}
      setPageSize={setPageSize}
      loading={loading}
    >
      <AuditLogsFilters
        allUsers={uniqueUsers}
        allEventTypes={Object.values(EventType)}
        onApplyFilters={(newFilters) => {
          setPage(1);
          setFilters(newFilters);
        }}
        setPage={setPage}
      />
    </AuditLogsTable>
  );
}

export default function AuditLogsPage() {
  const { formatMessage } = useIntl();

  return (
    <MainWrapper
      friendlyName={formatMessage(messages.title)}
      title={formatMessage(messages.title)}
    >
      <AuditLogsContent />
    </MainWrapper>
  );
}
